import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';

export default function JobTimer({ appointment, onUpdate }) {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let interval;
    if (appointment.timer_running && appointment.timer_started_at) {
      // Calculate elapsed time
      interval = setInterval(() => {
        const startTime = new Date(appointment.timer_started_at);
        const now = new Date();
        const elapsed = Math.floor((now - startTime) / 1000); // seconds
        setElapsedTime(elapsed);
      }, 1000);
    } else {
      setElapsedTime(0);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [appointment.timer_running, appointment.timer_started_at]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const handleStartTimer = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API}/appointments/${appointment.id}/start-timer`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Timer started!');
      onUpdate();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to start timer');
    } finally {
      setLoading(false);
    }
  };

  const handleStopTimer = async () => {
    if (!window.confirm('Stop timer and close job? This will create a work entry.')) return;
    
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API}/appointments/${appointment.id}/stop-timer`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`Timer stopped! ${response.data.hours_worked} hours tracked`);
      onUpdate();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to stop timer');
    } finally {
      setLoading(false);
    }
  };

  if (appointment.timer_running) {
    return (
      <div className="flex items-center gap-2">
        <div className="px-3 py-1 border-2 font-mono text-lg" style={{ 
          borderColor: '#00FF00', 
          color: '#00FF00',
          backgroundColor: '#001a00'
        }}>
          {formatTime(elapsedTime)}
        </div>
        <button
          onClick={handleStopTimer}
          disabled={loading}
          className="retro-btn retro-btn-magenta"
        >
          [STOP]
        </button>
      </div>
    );
  }

  // Don't show start button for closed jobs
  if (appointment.status === 'Closed') {
    return null;
  }

  return (
    <button
      onClick={handleStartTimer}
      disabled={loading}
      className="retro-btn retro-btn-green"
    >
      [START TIMER]
    </button>
  );
}
